import { useQuery } from "react-query";
import { getActiveAtClosedLocation } from "../../../../../actions/CarrierAgreementMgmt/Reports";

const useGetActiveAtClosedLocation = () => {
  return useQuery("GetActiveAtClosedLocation", getActiveAtClosedLocation, {
    refetchOnWindowFocus: false,
  });
};
export default useGetActiveAtClosedLocation;
